import { InventoryAdjustmentReasonUpdatePage } from '@/features/inventory-adjustment-reason/pages/InventoryAdjustmentReasonUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment-reason/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment_reason.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentReasonUpdatePage,
})
